import ModelList from './list';
import ModelDetail from './detail';
import AcceptanceList from './list-acceptance';

export default [
    {
        path: '/model/list',
        name: 'modelList',
        component: ModelList
    },
    {
        path: '/model/acceptance',
        name: 'acceptanceList',
        component: AcceptanceList
    },
    {
        path: '/model/detail/:id/:type/:taskId?/:date?/:explain?/:lang?',
        name: 'modelDetail',
        component: ModelDetail,
        meta: {
            noNeedLogin: true
        }
    }
];